export default "__VITE_ASSET__XiOj9MnA__"